<template>
  <div class="animated fadeIn overflow-auto" >
    
    <b-row>
      <b-col sm="12">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-arrow-left bg-primary p-3 font-2xl mr-3 float-left"  @click.stop.prevent="$router.go(-1)"> </i>

          
            <div class="h5 text-primary mb-0 pt-1">Todos os Estoques</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Painel de Estoque</div>
          
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>  
    <b-row>
      <b-col sm="12">
                <ul class="icons-list">
                    <li v-for="(value, key) in listaResumo.itens" >
                      <i class="icon-layers bg-gray-100"></i>
                      <div class="desc">
                        <div class="title">{{value.PARTE_TRADUZIDO}}</div>
                        <small>Todos os Estoques</small>
                      </div>
                      <div class="value">
                        <div class="small text-muted">PECAS: {{ value.PECAS }}</div>
                        <strong>{{value.QUANT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})}}</strong>
                      </div>
                    </li>  
                  </ul>  
        </b-col>                  
    
    
    </b-row>


<br/>

    <!--
    <b-row>
      <b-col sm="12">
                <ul class="icons-list">
                    <li v-for="(value, key) in listaResumo.itens" >
                      <i class="icon-layers bg-gray-100"></i>
                      <div class="desc">
                        <div class="title">{{value.PARTE_TRADUZIDO}}</div>
                        <small>Todos os Estoques</small>
                      </div>
                      <div class="value">
                        <div class="small text-muted">PECAS: {{ value.PECAS }}</div>
                        <strong>{{value.QUANT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})}}</strong>
                      </div>
                     
                      
                    </li>  
                  </ul>  
        </b-col>                  
    
    
    </b-row>
    -->
 
    <!-- --------------------- BOI ----------------------------- !-->
    <b-row>
      <b-col sm="12">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix bg-dark">
            <i class="fa fa-print bg-warning text-dark  p-3 font-2xl mr-0 float-right"   @click.stop.prevent="onImprimirEstoque()"  title="imprimir" v-b-tooltip.hover.down > </i>

          
            <div class="h5 text-white mb-1 mr-1 p-2 pt-3">LISTA DE PRODUTOS</div>
            
          
          </b-card-body>
          <b-row>
            <b-col sm="12">
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      class="sm"
                      type="search"
                      filter-debounce="200"
                      placeholder="Use (Código) ou Nome  ">
                    </b-form-input>

                    
                  </b-col>
          </b-row>

          
          <!--  -----------------------------------------------------------------------------------
                                          TABELA DE LISTAGEM - FILTRO 
                ----------------------------------------------------------------------------------- -->
                <b-table class="table table-sm"
                  show-empty
                  empty-text="Informe o filtro para ver os pesquisas "

                  stacked="md"
                  small
                  responsive 
                  hover 
                  select-mode="single"
                  selectable
                  
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  fixed
                  :items="listaEstoque.items" 
                  :fields="listaEstoque.colunas"
                  :current-page="listaEstoque.currentPage"
                  :per-page="listaEstoque.perPage"
                  :no-border-collapse="false"
                  >
                  
              <template #cell(actions)="item">
                <!--
                <b-button type="button" @click.stop.prevent="edit(item.item)"  size="sm" variant="primary" >
                  <i class="fa fa-folder-open-o"></i>
                </b-button>
                -->
                <b-button  type="button" 
                          @click.stop.prevent="abrirModalTrilha(item)"
                          size="sm" 
                          variant="secondary" 
                          title="Trilha de Auditoria" v-b-tooltip.hover.left >
                  
                  <i class="fa fa-info"></i>
                </b-button>

              </template>

          </b-table>
          
          <div class="justify-content-center row my-1">
            <b-pagination size="md" :total-rows="this.pesquisa.totalRows" :per-page="pesquisa.perPage" v-model="pesquisa.currentPage" />
          </div>
        </b-card>
      </b-col>
    </b-row>
   
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import {Money} from 'v-money'
import { Callout } from '../../components/'
import Alerts from '../notifications/Alerts.vue'
import Tools from '@/tools/tools.js'

export default {
  data () {
    return {
      filter : '',
      filterOn: [],
      listaResumo : {
        itens: []
      },
      listaEstoque : {
        totalRows : 1,
        currentPage: 1,
        perPage: 200,
        filter: null,
        items: [],
        colunas: [
          {
            key: "ID_PRODUTO",
            label: 'Id',
            sortable: true,
            thStyle: { width: '5% !important'},
            visible: true
          },
          {
            key: "DESCRICAO_PRODUTO",
            label: 'Produto',
            sortable: true ,
            thStyle: { width: '30% !important'} ,
            visible: true
          },
          {
            key: "DESCRICAO_CENTRO_ESTOQUE",
            label: 'Centro de Estoque',
            sortable: true ,
            thStyle: { width: '25% !important' },
            visible: true
            
          },
          {
            key: "PECAS",
            label: 'Volumes',
            class:'text-right',
            sortable: true,
            thStyle: { width: '10% !important'},
            visible: true
          },
          {
            key: "PECAS_RESERVADO",
            label: 'Reservado',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '10% !important'},
            visible: true
          },
          {
            key: "PECAS_DISPONIVEIS",
            label: 'Disponiveis',
            class:'text-right', 
            sortable: true,
            variant: 'warning',
            thStyle: { width: '10% !important'},
            visible: true
          },
          {
            key: "QUANT",
            label: 'Peso KG',
            class:'text-right',
            sortable: true,
            thStyle: { width: '15% !important'},
            visible: true,
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
          }
        ]
      },
      noBorderCollapse: false,
      show: false,
      minimoMoeda: 0,
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      exibePesquisa: false, 
      animais: {
        quarto: {
          quant: null,
          pecas: null,
          busy: false
        },
        banda: {
          quant: null,
          pecas: null,
          busy: false
        },
        caixaria: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          totalRows: 0,
          busy: false
        },
        vaca: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          busy: false
        },
        touro: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          busy: false
        },
        novilha: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          busy: false
        }
      },
      
      areceber10DiasTitulos: [],
      areceber10DiasDados: [
        {
          label: 'Valor R$:',
          backgroundColor: '#20a8d8',
          borderColor: 'rgba(255,255,255,.55)',
          data: []
        }
      ],
      pesquisa: {
        centroEstoqueId: null,
        produtoId: null,
        centroEstoque: {
          options: []
        },
        isLoading: false,
        status: '',
        isBusy: false,
        currentPage: 1,
        perPage: 30,
        sortBy: null,
        sortDesc: false,
        filter: null,
        items: [],
        fields: [
          {
            key: "INDICE",
            label: 'Etiqueta',
            sortable: true,
            thStyle: { width: '5% !important'}
          },
          {
            key: "PESO_TOTAL_DESCONTADO",
            label: 'RESTANTE',
            class:'text-right', 
            variant: "success",
            sortable: true,
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
          },
          {
            key: "BANDA1",
            label: 'BANDA A',
            variant: "info",
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})   
          },
          {
            key: "PESO_DIANTEIRO1",
            label: 'DT A',
            variant: "warning",
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})   
          },
          {
            key: "PESO_TRASEIRO1",
            label: 'TS A',
            class:'text-right', 
            sortable: true,
            variant: "warning",
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})   
          },
          {
            key: "BANDA2",
            label: 'BANDA B',
            class:'text-right',
            variant: "info",
            sortable: true,
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
          },
          {
            key: "PESO_DIANTEIRO2",
            label: 'DT B',
            variant: "warning",
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
          },
          {
            key: "PESO_TRASEIRO2",
            label: 'TS B',
            variant: "warning",
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})   
          },
          {
            key: "DT_LOTE",
            label: 'Abate',
            class:'text-right', 
            sortable: true,
            cellVariants:{'DT_LOTE' : 'dark'},
            thStyle: { width: '5% !important'},
            formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
          },
          {
            key: "GTA",
            label: 'GTA',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5% !important'}
          },
          {
            key: "NOME_FORNECEDOR",
            label: 'Fornecedor',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '8% !important'},
            formatter: (value, key, item) => 
              (value === null ? '' : value.substring(0, 8).concat('...'))
          }             
        ]
      },
    }
  },
  components: {
    VueButtonSpinner,
    ProdutoPesquisa,
    ClientePesquisa,
    Money,
    Callout,
    Alerts

  },
  computed: {
    
  },
  methods: {
    
    rowClassListagem(item, type) {
      if (item && type === 'row') {
        if ((item.SITUACAO_TRADUZIDO) && (item.SITUACAO_TRADUZIDO.trim() === 'CANCELADO')) {
          return 'text-danger'
        } else {
          return null
        } 
      } else {
        return null
      }
    },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.listaEstoque.totalRows = filteredItems.length
        this.listaEstoque.currentPage = 1
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    filtrar (ctx) {
      
    },
    colorirPecas(value) {
      let $variant
      if ( value > 0  ) {
        $variant = 'warning'
      } else {
        $variant = 'danger'
      }
      return $variant
    },
    onImprimirMiudo() {
      this.animais.quarto.busy = true
      let uri = `/api/protected/relatorios/estoque/relestoquesinteticotodoscentros?lbusuario=${window.localStorage.getItem('nomeusuario')}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          this.animais.quarto.busy = false
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relEstoqueMiudos.pdf')
          link.download = 'relEstoque.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Estoque dos Miúdos'
            }, 1000);
          }
        })
        .catch(erro => {
          let msg = erro.response.text
          this.$root.$bvToast.toast(`Falha ao gerar o relatório!!! ` + msg, {
            title: 'Falha',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
          this.pesquisa.isLoading = false
          this.animais.quarto.busy = false
        })
    },
    onImprimirEstoque () {
      
      
      let uri = `/api/protected/relatorios/estoque/relestoquesinteticotodoscentros?usuarioId=${window.localStorage.getItem('usuarioId')}`
      this.$store.commit('controle/setAguardando', true)
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relEstoque.pdf')
          link.download = 'relEstoque.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Estoque'
            }, 1000);
          }
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Relatório Indisponível', 'danger', erro.response.data || 'Falha ao gerar o relatório!!! ')
        })

    },
    focusModalPagar() {
      this.$refs.tipoPagamento.focus()
      this.atualizaContas()
    },
    atualizarListas() {
      this.$store.commit('controle/setAguardando', true)
      this.$http.get(`/api/protected/estoque/pesquisarSintetico?usuarioId=${window.localStorage.getItem('usuarioId')}`)
      .then((data) => {
          this.listaEstoque.items = data.data
          this.$http.get(`/api/protected/estoque/getResumoProdutosTipo`)
          .then(result => {
              this.listaResumo.itens = result.data
              this.$store.commit('controle/setAguardando', false)
          })
      }).catch((erro) => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        } else {
        
          this.$root.$bvToast.toast(`Os ESTOQUES estão indisponíveis!!! !! `, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
      /*.then((data) => {
          this.listaEstoque.items = data.data
          this.$http.get(`/api/protected/estoque/getResumoProdutosTipo`)
          .then(result => {
              this.listaResumo.itens = result.data
              this.$store.commit('controle/setAguardando', false)
          })
      }).catch((erro) => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        } else {
        
          this.$root.$bvToast.toast(`Os ESTOQUES estão indisponíveis!!! !! `, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        }
      })*/
    }
  },
  created () {
    
    this.atualizarListas()
    
  },
  watch: {
  }
}
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/views/estoque/EstoqueProducao.vue